$(document).on('turbo:load', function() {

  const fddRefilingModal = $('#fdd-refiling-modal');

  $('#two-minute-drill-top-form input[type="file"][name="hs_brand[fdd_upload]"]').change(function () {
    const form = $(this).closest('form')
    // Only trigger change on FDD field for refiling if the brand has already been through onboarding.
    if (form.find('input[name="onboarding"]').val() === 'true') return;
    triggerFDDChanged();
  });

  function triggerFDDChanged() {
    showFDDRefilingModal();
    clearFDDFields();
  }

  /**
   * Popup FDD Refiling modal to let the user know what all they will need to do after uploading their FDD.
   */
  function showFDDRefilingModal() {
    fddRefilingModal.modal({backdrop: 'static', keyboard: false}).modal('show');
  }

  /**
   * Clear out fields related to FDD and apply a styling to them with the old values baked in so they remember what
   * used to be there.
   */
  function clearFDDFields() {
    $('#two-minute-drill-top-form .fdd-refiling-required').each(function() {
      if ($(this).closest('.fdd-refiling-cleared-field').length) return; // This must be the second time this was called, don't do it again.

      const prevValue = $(this).val();
      console.log($(this).attr('name'));
      if ($(this).attr('name').match(/^hs_brand\[registration_.+]$/i)) {
        // Registration state field, instead of setting to null, set to Not Registered or Pending.
        if (prevValue !== 'Not Registered') $(this).val('Pending');
      } else $(this).val(null); // Otherwise, clear out the field to null.

      // Wrap this field in styled box that displays the previous value and brings attention to this field.
      $(this).wrap('<div class="fdd-refiling-cleared-field"></div>');
      $(`<h3 class="ms-2">Previously: ${prevValue || 'Blank'}</h3>`).insertBefore(this);
    });
  }

  /**
   * FPO: The rest of this file should be commented out in any commit.
   */
  // triggerFDDChanged();
  // showFDDRefilingModal();
  // clearFDDFields();

});
